import Vue from "vue";
import Vuex from "vuex";

import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    data: {},
    reported: false,
    email: "",
    name: "",
    group: {},
    current: 1,
    value: {},
    congregations: [],
    newsletter: false,
    token: false,
  },
  mutations: {
    SET_CONGREGATIONS(state, data) {
      state.congregations = Object.freeze(data);
    },
    SET_DATA(state, data) {
      state.data = data;
    },
    SET_TOKEN(state, data) {
      state.token = data;
    },
    SET_REPORTED(state, data) {
      state.reported = data;
    },
    SET_EMAIL(state, data) {
      state.email = data;
    },
    SET_NAME(state, data) {
      state.name = data;
    },
    SET_GROUP(state, data) {
      state.group = data;
    },
    SET_CURRENT(state, data) {
      state.current = data;
    },
    SET_NEWSLETTER(state, data) {
      state.newsletter = data;
    },
    SET_VALUE(state, data) {
      state.value = data;
    },
  },
  actions: {
    setCongregations(context, newValue) {
      context.commit("SET_CONGREGATIONS", newValue);
    },
    setNewsletter(context, newValue) {
      context.commit("SET_NEWSLETTER", newValue);
    },
    setCurrent(context, newValue) {
      context.commit("SET_CURRENT", newValue);
    },
    setReported(context, newValue) {
      context.commit("SET_REPORTED", newValue);
    },
    setValue(context, newValue) {
      context.commit("SET_VALUE", newValue);
    },
    setToken(context, newValue) {
      context.commit("SET_TOKEN", newValue);
    },
    setData(context, newValue) {
      context.commit("SET_DATA", newValue);
    },
    setEmail(context, newValue) {
      context.commit("SET_EMAIL", newValue);
    },
    setName(context, newValue) {
      context.commit("SET_NAME", newValue);
    },
    setGroup(context, newValue) {
      context.commit("SET_GROUP", newValue);
    },
  },
  modules: {},
  strict: true,
  plugins: [vuexLocal.plugin],
});
